module.exports = __webpack_public_path__ + "img/DDP-Schematics-01.4b7111e2.svg";